module.exports = __webpack_public_path__ + "img/DK64806815.fd431700.png";